<template>
	<div class="slider">
		<b-carousel :interval="5000" fade indicators class="carousel-slider">
			<b-carousel-slide
				v-for="(sliderEntry, index) in sliders"
				:key="index"
				:img-src="sliderEntry.imgSrc"
				:img-alt="sliderEntry.imgAlt"
			>
				<div class="slider-content">
					<div class="slider-capiton">
						<h2>
							{{ sliderEntry.content.caption }}
						</h2>
					</div>
					<div class="slider-subcaption">
						{{ sliderEntry.content.subcaption }}
					</div>
					<router-link
						class="slider-action-btn"
						tag="input"
						type="button"
						:value="sliderEntry.content.btnText"
						:to="sliderEntry.content.btnHref"
					/>
				</div>
			</b-carousel-slide>
		</b-carousel>
	</div>
</template>

<script>
export default {
	props: {
		sliders: {
			type: Array,
			required: true,
		},
	},
}
</script>

<style lang="scss">
@include media-breakpoint-up(xs) {
	.slider {
		max-width: 100%;
	}
	@keyframes title-anim {
		0% {
			transform: translateX(-100vw);
		}
		100% {
			transform: translateX(0);
		}
	}
	.carousel-slider {
		height: 100vh;
		max-width: 100%;
	}
	.carousel-item {
		// overflow: hidden;
		img {
			height: 100vh;
			object-fit: cover;
		}
	}
	.carousel-caption {
		position: absolute;
		top: 0 !important;
		bottom: 0 !important;
		right: 0 !important;
		left: 0 !important;
		@include d-flex-column;
		align-items: center;
		justify-content: center;
		padding: 0 !important;
		background: rgba($color: #222, $alpha: 0.3);
	}
	.slider-content {
		@include d-flex-column;
		border-top-right-radius: 5em;
		border-bottom-right-radius: 5em;
		border-radius: 5px;
		text-align: left;
		overflow: hidden;
		justify-content: center;
		align-items: center;
		.slider-capiton,
		.slider-subcaption {
			text-align: center;
			margin: 2px 1em;
			padding: 0;
			text-transform: uppercase;
		}

		.slider-capiton {
			color: #fff;
			h2 {
				font-weight: 400;
				font-size: 1.6em;
			}
		}
		.slider-subcaption {
			color: #fff;
			font-size: 1em;
			// background: $-color;
			// display: none;
		}
		.slider-action-btn {
			text-transform: uppercase;
			font-weight: 400;
			position: relative;
			align-self: center;
			background-color: transparent;
			border-left: 4px solid #fff;
			border-top: 4px solid #fff;
			border-right: 4px solid $main-color;
			border-bottom: 4px solid $main-color;
			color: #fff;
			border-radius: 30px;
			box-shadow: none;
			padding: 0.5em 1.5em;
			margin: 1em 0;
			width: fit-content;
			font-size: 1em;
			&:hover {
				background-color: $main-color;
			}
			box-sizing: border-box;
			transition: background 0.3s;
		}
	}
}

@include media-breakpoint-up(sm) {
}
@include media-breakpoint-up(md) {
	.carousel-slider {
	}
	.carousel-item {
		img {
		}
	}
	.carousel-caption {
	}
	.slider-content {
		.slider-capiton {
			h2 {
				font-weight: 100;
				font-size: 2.5em;
			}
		}
		.slider-subcaption {
			width: fit-content;
			font-size: 1.6em;
			padding: 4px;
		}
		.slider-action-btn {
			&:hover {
			}
		}
	}
}
@include media-breakpoint-up(lg) {
}
@include media-breakpoint-up(xl) {
}
</style>
